<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Bank Guarantee List
      </span>
      <a-button-group ghost>
        <!-- <a-button @click="handleReload" icon="reload">
          <span>Reload</span>
        </a-button> -->
        <a-button icon="plus" type="primary" @click="handleCreate">
          <span>Create</span>
        </a-button>
      </a-button-group>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" :onchange="moreSearch" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button :class="getScreen ? 'margin-top' : ''" block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button>
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 11 }">
            <div class="m-form-item-wrapper">
              <label>Bank Account</label>
              <a-select placeholder="All Bank Account" v-model="typebankaccount" class="width-full" initialValue="all"
                :filterOption="filterOption" showSearch allowClear>
                <a-select-option v-for="item in bank" :key="item.value" :value="item.value">{{ item.text
                }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select showSearch v-model="typestatus" placeholder="All Status" class="width-full" initialValue="all"
                allowClear :filterOption="filterOption">
                <a-select-option value="A">Active</a-select-option>
                <a-select-option value="N">Non Active</a-select-option>
              </a-select>
            </div>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div
              class="m-form-item-wrapper"
            >
              <label>Type</label>
              <a-select
                showSearch
                v-model="type_debcred"
                placeholder="All Type"
                class="width-full"
                initialValue="undefined"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="Debit">Debit</a-select-option>
                <a-select-option value="Credit">Credit</a-select-option>
              </a-select>
            </div>
          </a-col> -->
        </a-row>
      </a-card>
      <div class="bordered">
        <a-table rowKey="bank_garansi_id" key="dtguarantee" size="small" bordered :scroll="{ x: 1300 }" :columns="columns"
          :dataSource="tempdatareconcile" :loading="loading">
          <template slot="nomor" slot-scope="text, data, index">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="val" slot-scope="text, data">
            <!-- <span>{{ formatRupiah(data.value) }}</span> -->
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="(data.value ? data.value : 0)" />
          </template>
          <template slot="reqGuarantee" slot-scope="text, data">
            {{ data.bidbond_notrans }}<br />
            {{ data.bidbond_companion }}<br />
            {{ formatRupiah(data.bidbond_nominal) }}
          </template>
          <template slot="activests" slot-scope="text, data, index">
            <span v-if="data.active == 'Active' && !data.cancel_sts">{{ data.active == 'Active' ? data.active :
              data.active_sts }} - {{ data.tlc_create }}
              / {{ moment(data.create_dt).format("DD-MM-YYYY") }}</span>
            <span v-if="data.active == 'Non Active'">{{ data.active_sts }}</span>
            <span v-if="data.cancel_sts">
              {{ data.cancel_sts }}
            </span>
          </template>
          <template slot="act" slot-scope="text, data">
            <a-button-group>
              <a-button :disabled="data.aksi_non_active == 'disabled'" type="primary" @click="handleaktifasi(data)">
                Set NonActive
              </a-button>
              <a-button :disabled="!data.file_url" type="default" @click="handleViewFile(data)" icon="eye">
              </a-button>
              <a-button type="danger" @click="handleCancel(data)" :disabled="data.aksi_cancel === 'enabled' ? false : true
                " icon="close-square">
              </a-button>
            </a-button-group>
          </template>
        </a-table>
      </div>
    </div>

    <a-modal v-if="modalCreate" v-model="modalCreate" title="Create Bank Guarantee" :width="600" centered
      :maskClosable="false" @ok="handleOk" @cancel="handleClose" okText="OK" cancelText="Cancel">
      <a-form-model ref="guaranteeform" :model="form" :rules="rules">
        <a-row :gutter="24">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="date" label="Date" prop="date">
              <a-date-picker v-model="form.date" format="DD-MM-YYYY" />
            </a-form-model-item>
            <a-form-model-item ref="type" label="Type" prop="type">
              <a-radio-group buttonStyle="solid" v-model="form.type_bank_guarantee">
                <a-radio-button value="1">Bloked Fund</a-radio-button>
                <a-radio-button value="2">PBG</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item ref="bank" label="Bank Account" prop="bank">
              <a-select placeholder="All Bank Account" v-model="form.bank" class="width-full" :filterOption="filterOption"
                showSearch allowClear @blur="() => {
                  $refs.bank.onFieldBlur();
                }
                  ">
                <a-select-option v-for="item in bank" :key="item.value" :value="item.value">{{ item.text
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item ref="reqGuarantee" label="No. Request Guarantee" prop="reqGuarantee">
              <div class="m-form-item-wrapper">
                <a-select placeholder="All Request Guarantee" v-model="form.reqGuarantee" class="m-select width-full"
                  :filterOption="filterOptionNoGuarantee" showSearch allowClear @blur="() => {
                    $refs.reqGuarantee.onFieldBlur();
                  }
                    ">
                  <a-select-option v-for="item in reqGuaranteeList" :key="item.id" :value="item.id">
                    <div>
                      <b>{{ item.no_trans }}</b> | {{ item.companion_nm }} | {{ formatRupiah(item.nominal) }}
                    </div>
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
            <a-form-model-item ref="description" label="Description" prop="description">
              <a-input v-model="form.description" @blur="() => {
                $refs.description.onFieldBlur();
              }
                " />
            </a-form-model-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-model-item ref="duedate" label="Guarantee Period Bank" prop="duedate">
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="form.duedate"
                :format="getDefaultDateFormat" allowClear />
            </a-form-model-item>
            <a-form-model-item ref="valu" label="Value (IDR)" prop="valu">
              <a-input-number :min="0" class="m-width-full m-text-align right" @keydown="onlyNumber" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-model="form.valu"></a-input-number>
            </a-form-model-item>
            <a-form-model-item ref="note" label="Note" prop="note">
              <a-textarea v-model="form.note" @blur="() => {
                $refs.note.onFieldBlur();
              }
                " />
            </a-form-model-item>
            <a-form-model-item ref="file" prop="file" label="File Attachment">
              <a-upload v-model="form.file" :showUploadList="true" :beforeUpload="beforeUpload"
                :remove="handleRemoveList">
                <a-button ref="btndocument" icon="upload">Select File
                </a-button>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
        <template slot="footer">
          <a-button key="back" @click="handleClose"> Cancel </a-button>
          <!-- <a-button @click="handleClose()">Tutup</a-button> -->

        </template>
      </a-form-model>
    </a-modal>

    <a-modal v-if="modalsetnonactive" v-model="modalsetnonactive" title="Set Non Active Form" :width="500" centered
      :maskClosable="false">
      <a-form-model ref="nonActiveform" :model="formsetnonactive" :rules="rulessetnonactive">
        <a-form-model-item ref="id" label="id" prop="id" hidden="true">
          <a-input v-model="formsetnonactive.id" @blur="() => {
            $refs.id.onFieldBlur();
          }
            " />
        </a-form-model-item>
        <a-form-model-item ref="notrans" label="No Transaction" prop="notrans">
          <a-input v-model="formsetnonactive.notrans" @blur="() => {
            $refs.notrans.onFieldBlur();
          }
            " :disabled="true" />
        </a-form-model-item>
        <a-form-model-item ref="date" label="Date" prop="date">
          <a-date-picker v-model="formsetnonactive.date" format="DD-MM-YYYY" :allowClear="false" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button type="danger" key="back" @click="handleClosesetnonactive"> Cancel </a-button>
        <a-button type="primary" key="submit" :loading="loadingsetnonactive" @click="handleOksetnonactive"> OK </a-button>
        <!-- <a-button @click="handleClose()">Tutup</a-button> -->

      </template>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "reconcile-index",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  props: {
    props_invoice_no: String
  },
  data() {
    const columns = [
      {
        title: "No Transaction",
        key: "nomor",
        dataIndex: "no_transaction",
        width: 200,
      },
      {
        title: "Date",
        key: "date",
        dataIndex: "date",
        width: 100,
        align: "center",
      },
      {
        title: "Bank Account",
        key: "bankacount",
        dataIndex: "bank_account",
        width: 300,
      },
      {
        title: "Guarantee Period Bank",
        key: "duedate",
        dataIndex: "due_date",
        align: "center",
        width: 200,
      },
      {
        title: "No. Request Guarantee",
        key: "reqGuarantee",
        scopedSlots: { customRender: "reqGuarantee" },
        width: 250,
      },
      {
        title: "Description",
        key: "description",
        width: 200,
        dataIndex: "description",
      },
      {
        title: "Value (IDR)",
        key: "val",
        scopedSlots: { customRender: "val" },
        width: 150,
      },
      {
        title: "Status",
        key: "activests",
        scopedSlots: { customRender: "activests" },
        width: 180,
      },
      {
        title: "Note",
        key: "note",
        width: 200,
        dataIndex: "note",
      },
      {
        title: "Type",
        key: "type",
        width: 200,
        dataIndex: "type",
      },
      {
        title: "Action",
        key: "act",
        scopedSlots: { customRender: "act" },
        width: 200,
        align: "center",
      },
    ];
    return {
      columns,
      tempdatareconcile: [],
      datareconcile: [],
      loading: false,
      loadingsetnonactive: false,
      search: undefined,
      typebankaccount: undefined,
      transactionDt: [],
      advancedsearch: "display:none",
      typestatus: undefined,
      supplier_nm: undefined,
      //type_debcred: undefined,
      bank: [],
      reqGuaranteeList: [],
      modalCreate: false,
      modalsetnonactive: false,
      form: {
        date: moment(),
        type_bank_guarantee: "1",
        bank: null,
        description: null,
        duedate: [],
        valu: 0,
        note: "",
        file: [],
        reqGuarantee: null
      },
      formsetnonactive: {
        id: null,
        notrans: null,
        date: moment(),
      },
      rules: {
        date: [
          {
            required: true,
            message: "Please input Date",
            trigger: "change",
          },
        ],
        type_bank_guarantee: [
          {
            required: true,
            message: "Please input Type",
            trigger: "change",
          },
        ],
        bank: [
          {
            required: true,
            message: "Please input Bank Account",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "Please input Description",
            trigger: "blur",
          },
        ],
        duedate: [
          {
            required: true,
            message: "Please input Due Date",
            trigger: "blur",
          },
        ],
        valu: [
          {
            required: true,
            message: "Please input Value",
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: "Please input Note",
            trigger: "blur",
          },
        ],
        file: [
          {
            required: true,
            message: "Please input File Attachment",
            trigger: "change",
          },
        ],
        reqGuarantee: [
          {
            required: true,
            message: "Please input No. Request Guarantee",
            trigger: "blur",
          },
        ],
      },
      rulessetnonactive: {
        id: [
          {
            required: true,
            message: "Please input Id",
            trigger: "change",
          },
        ],
        notrans: [
          {
            required: true,
            message: "Please input No transaction",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "Please input Date",
            trigger: "change",
          },
        ],
      }
    };
  },
  mounted() {
    this.handleReload().then(() => {
      if (this.props_invoice_no) {
        let isExistInvoice = _.filter(this.reqGuaranteeList, e => e.no_trans == this.props_invoice_no)
        if (isExistInvoice.length == 0) {
          this.displayMessageValue("error-other", "No. Request Guarantee Not Found!");
        } else {
          this.form.reqGuarantee = isExistInvoice[0].id
          this.modalCreate = true;
        }
      }
    });
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    moreSearch: function () {
      let tempfilter = this.datareconcile;
      if (this.datareconcile.length > 0) {
        if (this.search) {
          tempfilter = tempfilter.filter(
            (obj) =>
            (obj.allstring &&
              obj.allstring
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
          );
        }

        if (this.typebankaccount) {
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.bank_account_id && obj.bank_account_id == this.typebankaccount
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          let startDt = moment(this.transactionDt[0]).format("DD-MM-YYYY");
          let endDt = moment(this.transactionDt[1]).format("DD-MM-YYYY");
          tempfilter = tempfilter.filter(
            (obj) =>
              obj.date &&
              moment(moment(obj.date, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY") >= startDt &&
              moment(moment(obj.date, "DD-MM-YYYY").toDate()).format("DD-MM-YYYY") <= endDt
          );

        }

        if (this.typestatus) {
          if (this.typestatus == "A") {
            tempfilter = tempfilter.filter(
              (obj) =>
              (obj.active &&
                obj.active
                  .toLowerCase()
                  .indexOf(("Canceled by").toLowerCase()) >= 0)
            );
          } else {
            tempfilter = tempfilter.filter(
              (obj) =>
              (obj.active &&
                obj.active
                  .toLowerCase()
                  .indexOf(("Active").toLowerCase()) >= 0));
          }
        }

        // if (this.type_debcred) {
        //   if (this.type_debcred) {
        //     tempfilter = tempfilter.filter(
        //       (obj) => obj.type && obj.type == this.type_debcred
        //     );
        //   }
        // }
      }

      if (
        (!this.search || this.search == "") &&
        (!this.transactionDt || this.transactionDt.length == 0) &&
        !this.typebankaccount &&
        !this.typestatus //&&
        //!this.type_debcred
      ) {
        tempfilter = this.datareconcile;
      }

      this.tempdatareconcile = tempfilter;
      return true;
    },
  },
  created() {
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionNoGuarantee(input, option) {
      return (
        option.componentOptions.children[0].elm.innerText
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typebankaccount = undefined;
      this.typestatus = undefined;
      //this.type_debcred = undefined;
    },
    intoList(type, value) {
      if (type == "release") {
        this.release = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    async handleReload() {
      this.loading = true;
      await this.$store.dispatch("getbankguaranteelist", { auth: this.getAuth }).then((res) => {
        this.bank = res.data.bank_account;
        this.reqGuaranteeList = res.data.no_req_guarantee;
      });
      await this.$store.dispatch("getDataBankGuarantee", { auth: this.getAuth }).then((res) => {
        this.datareconcile = res.data;
        this.datareconcile.forEach((element, index) => {
          this.datareconcile[index].allstring = (element.no_transaction ? element.no_transaction : "")
            + (element.date ? element.date : "")
            + (element.bank_account ? element.bank_account : "")
            + (element.description ? element.description : "")
            + (element.note ? element.note : "")
            + (element.value ? this.formatRupiah(element.value) : "")
            + (element.due_date ? element.due_date : "")
            + (element.active ? element.active : "")
            + (element.cancel_sts ? element.cancel_sts : "")
        });

        this.tempdatareconcile = this.datareconcile;
        this.loading = false;
      });
      this.resetSearch();
    },
    resetform() {
      this.form = {
        date: moment(),
        type_bank_guarantee: "1",
        bank: null,
        description: null,
        duedate: [],
        valu: 0,
        note: "",
        file: [],
        reqGuarantee: null,
      };
    },
    handleCreate() {
      // this.$router.push({
      //   name: "account-pay-create",
      //   params: { id: item.id, type: item.jenis_id },
      // });
      this.resetform();
      this.modalCreate = true;
    },
    handleCancel(item) {
      const that = this;
      this.$confirm({
        title: "Are you sure to cancel this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let params = new FormData();
          params.append("tlc", that.getAuth.username);
          params.append("bank_garansi_id", item.bank_garansi_id);
          that.loading = true;
          that.$store.dispatch("cancelBankGuarantee", { auth: that.getAuth, params })
            .then((res) => {
              if (res.data.status == true) {
                that.displayMessageValue("success-other", res.data.message);
                that.handleReload();
              } else {
                that.displayMessageValue(
                  "error-other",
                  res.data.message
                );
              }
              that.loading = false;
            })
            .catch(err => {
              console.log(err);
              that.loading = false;
            });
        },
        onCancel() { },
      });
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    handleViewFile(item) {
      window.open(this.$serviceUrl + item.file_url);
    },
    handleRemoveList() {
      this.form.file = undefined;
    },
    beforeUpload(file) {
      this.form.file = [file];
      return false;
    },
    handleClose() {
      //this.$refs.guaranteeform.resetFields();
      this.$refs.file = null;
      this.modalCreate = false;
    },
    handleClosesetnonactive() {
      this.modalsetnonactive = false;
    },
    handleOk() {
      this.$refs.guaranteeform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("tlc", this.getAuth.username);
        formData.append("date", moment(this.form.date).format('YYYY-MM-DD'));
        formData.append("type_bank_guarantee", this.form.type_bank_guarantee);
        formData.append("bank_account", this.form.bank);
        formData.append("no_req_guarantee", this.form.reqGuarantee);
        formData.append("start_due_date", moment(this.form.duedate[0]).format('YYYY-MM-DD'));
        formData.append("end_due_date", moment(this.form.duedate[1]).format('YYYY-MM-DD'));
        formData.append("description", this.form.description);
        formData.append("value", this.form.valu);
        formData.append("note", this.form.note);
        formData.append("upload_file", this.form.file[0]);

        this.loading = true;
        this.$store.dispatch("createBankGuarantee", {
          auth: this.getAuth,
          params: formData
        })
          .then((res) => {
            if (res.data.status == true) {
              this.displayMessageValue("success-other", res.data.message);
              //this.$refs.guaranteeform.resetFields();
              this.$nextTick(() => {
                this.form.file = undefined;
              });
              this.handleReload();
            } else {
              this.displayMessageValue(
                "error-other",
                res.data.message
              );
            }
            this.loading = false;

          })
          .catch(err => {
            console.log("err", err);
            this.loading = false;
          });
        this.modalCreate = false;
      });
    },
    handleaktifasi(item) {
      this.modalsetnonactive = true;
      this.formsetnonactive.id = item.bank_garansi_id;
      this.formsetnonactive.notrans = item.no_transaction;
      this.formsetnonactive.date = moment();
      // const that = this;
      // this.$confirm({
      //   title: "Are you sure to set non active this data?",
      //   content: "",
      //   okText:"Yes",
      //   cancelText:"No",
      //   onOk() {
      //     let params = new FormData();
      //     params.append("tlc",that.getAuth.username);
      //     params.append("bank_garansi_id",item.bank_garansi_id);
      //     that.loading = true;
      //     that.$store.dispatch("nonActiveBankGuarantee", { auth: that.getAuth, params })
      //     .then((res) => {
      //       if(res.data.status==true){
      //         that.displayMessageValue("success-other", res.data.message);
      //         that.handleReload();
      //       }else{
      //         that.displayMessageValue(
      //           "error-other",
      //           res.data.message
      //         );
      //       }
      //       that.loading = false;
      //     })
      //     .catch(err => {
      //       console.log(err);
      //         that.loading = false;
      //     });
      //   },
      //     onCancel() {},
      //   });
    },
    handleOksetnonactive() {
      this.$refs.nonActiveform.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let params = new FormData();
        params.append("tlc", this.getAuth.username);
        params.append("bank_garansi_id", this.formsetnonactive.id);
        params.append("date", moment(this.formsetnonactive.date).format("YYYY-MM-DD"));
        this.loadingsetnonactive = true;
        this.$store.dispatch("nonActiveBankGuarantee", { auth: this.getAuth, params })
          .then((res) => {
            if (res.data.status == true) {
              this.displayMessageValue("success-other", res.data.message);
              this.handleReload();
            } else {
              if (res.data.message) {
                this.displayMessageValue(
                  "error-other",
                  res.data.message
                );
              } else {
                let responses = Object.assign({}, res);
                this.displayMessageValue("error", responses);
              }
            }
            this.modalsetnonactive = false;
            this.loadingsetnonactive = false;
          })
          .catch(err => {
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err);
              this.displayMessageValue("error", responses);
            }
            this.modalsetnonactive = false;
            this.loadingsetnonactive = false;
          });
      });
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
